<section class="hd-planet-influence-page">
  <table class="hd-planet-influence-table">
    <thead>
      <tr>
        <th>Type</th>
        <th>Sym.</th>
        <th>Planeet</th>
        <th>Essentie</th>
        <th>Rave Psych. / PHS</th>
        <th>In gedefinieerd kanaal</th>
        <th>In gedefinieerd center</th>
        <th>In ongedefinieerd center</th>
        <th>Invloed op</th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows(); track row.planetKey) {
        <tr [style.--planet-stripe-color]="row.stripeColor">
          <td class="cell-type">{{ row.typeLabel }}</td>
          <td class="cell-symbol">{{ row.astronomiconChar }}</td>
          <td class="cell-name">{{ row.planetLabel }}</td>
          <td>{{ row.essence }}</td>
          <td>
            <div class="psych-mind">{{ row.ravePsychology }}</div>
            <div class="psych-body">{{ row.phs }}</div>
          </td>
          <td>{{ row.inDefinedChannel }}</td>
          <td>{{ row.inDefinedCenter }}</td>
          <td>{{ row.inUndefinedCenter }}</td>
          <td>
            @for (seg of row.influenceOnSegments; track $index) {
              @if (seg.role === 'plain') {
                <span>{{ seg.text }}</span>
              } @else {
                <span class="marker-word"
                      [class.marker-personality]="seg.role === 'personality'"
                      [class.marker-design]="seg.role === 'design'">
                  {{ seg.text }}<sup>{{ seg.markerSuperscript }}</sup>
                </span>
              }
            }
          </td>
        </tr>
      }
    </tbody>
  </table>

  <div class="hd-planet-influence-page__legend">
    <span class="marker-personality"><sup>p</sup> personality</span>
    <span class="marker-design"><sup>d</sup> design</span>
  </div>
</section>
